export default __webpack_public_path__ + "static/media/Shot_8.0000.cc5b2cb3.png";